





























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class FixedAssetImport extends Vue {
    @Prop({ type: String })
    period!: string;

    @Prop({ type: Number })
    assetType!: number;

    fileData: any = null;
    // 下载模板
    startDownload: boolean = false;

    get title() {
        switch (this.assetType) {
            case 1: return "固定资产";
            case 2: return "无形资产";
            case 3: return "长期待摊费用";
        }
    }

    get templateUrl() {
        switch (this.assetType) {
            case 1: return "https://hongfund-desktop.oss-cn-shanghai.aliyuncs.com/%E5%9B%BA%E5%AE%9A%E8%B5%84%E4%BA%A7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls";
            case 2: return "https://hongfund-desktop.oss-cn-shanghai.aliyuncs.com/%E6%97%A0%E5%BD%A2%E8%B5%84%E4%BA%A7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls";
            case 3: return "https://hongfund-desktop.oss-cn-shanghai.aliyuncs.com/%E9%95%BF%E6%9C%9F%E5%BE%85%E6%91%8A%E8%B4%B9%E7%94%A8%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls";
        }
    }

    downloadExcel() {
        this.startDownload = true;
    }
    changeFile(e: any) {
        if (e.target.files[0]) {
            let file = e.target.files[0];
            let data = new FormData();
            data.append("file", file);
            data.append("accountBookId", this.$store.state.accountBook.id);
            data.append("endPeriod", this.period);
            data.append("fileName", file.name);
            data.append("assetType", this.assetType.toString());

            e.target.value = null;
            this.fileData = data;
        }
    }

    confirm() {
        Vue.axios
            .post(`upload/fixedassets`, this.fileData)
            .then(res => {
                this.fileData = null;
                this.$message.success(res.data.data);
                this.$emit("finish");
            }).catch(res => {
                this.$message.warning(res.data.message);
            });
    }
    closeDialog() {
        this.$emit("close");
    }

}
